


























import { Vue, Component, State, namespace } from 'nuxt-property-decorator'
import SelectedTagItem from '~/components/experience/destinations-category-tree/tag.vue'
import { Experience } from '~/types/experience'

import TreeNode = Experience.TreeNode

const experience = namespace('experience')

@Component({
  components: {
    SelectedTagItem
  }
})

export default class SelectedTagList extends Vue {
  @State klook!: Data.Klook
  @experience.Action setUrlQuery!: Function
  @experience.Action setSelectedRanges!: Function
  @experience.Action setSelectedCategory!: Function
  @experience.State selectedRanges!: any
  @experience.State selectedCategory!: any

  get ranges() {
    const range = this.selectedRanges.filter((item: TreeNode) => {
      return item.type === 'range'
    })
    return range
  }

  tagVisible(tag: TreeNode) {
    const id = tag.rangeId || -1
    if ((this.selectedRanges.rangeId || {})[id]) {
      return false
    }
    return true
  }

  get showSelected() {
    let show = false
    if (this.selectedRanges) {
      Object.keys(this.selectedRanges).forEach((item: any) => {
        if (this.selectedRanges[item] && Object.keys(this.selectedRanges[item]).length > 0) {
          show = true
        }
      })
    }

    if (this.selectedCategory && Object.keys(this.selectedCategory).length > 0) {
      show = true
    }
    return show
  }

  async clearRange(val: TreeNode, type: 'rangeId' | 'countryId' | 'cityId', key: number) {
    const obj = JSON.parse(JSON.stringify(this.selectedRanges))
    if (type === 'rangeId') {
      Object.keys(obj.countryId).forEach((countryId: any) => {
        if (obj.countryId[countryId].rangeId === val.id) {
          delete obj.countryId[countryId]
        }
      })
    }
    delete obj[type][key]
    this.setSelectedRanges(obj)
    await this.setUrlQuery({
      range_id: Object.keys(obj.rangeId).join(','),
      country_ids: Object.keys(obj.countryId).join(','),
      city_ids: Object.keys(obj.cityId).join(','),
      page: 1
    })
  }

  async clearCategory(key: any) {
    const obj = JSON.parse(JSON.stringify(this.selectedCategory))
    delete obj[key]
    this.setSelectedCategory(obj)
    await this.setUrlQuery({
      frontend_id_list: Object.keys(obj).join(','),
      page: 1
    })
  }

  async clearChecked() {
    this.setSelectedRanges(null)
    this.setSelectedCategory(null)
    await this.setUrlQuery({
      range_id: '',
      country_ids: '',
      city_ids: '',
      frontend_id_list: '',
      page: 1
    })
  }
}
